import { useState } from "react";
import { FaFacebook, FaInstagram, FaTripadvisor } from 'react-icons/fa'
import fourInABedWinner from './../assets/images/Awards/fouInABedWinner.png'
import foodHygieneRating from './../assets/images/Awards/foodHygieneRating.png'

const Footer = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        const mailchimpUrl = "https://foxinn-stourton.us18.list-manage.com/subscribe/post?u=3a377c3f23a9a856453ae4700&amp;id=ab1a408433&amp;f_id=00353ee1f0";

        const formData = new FormData();
        formData.append("EMAIL", email);

        try {
            await fetch(mailchimpUrl, {
                method: "POST",
                body: formData,
                mode: "no-cors"
            });

            setMessage("Thank you for subscribing!");
            setEmail("");
        } catch (error) {
            setMessage("Something went wrong. Please try again.");
        }
    };

  return (
    <div className='w-full bg-gray-900 text-gray-300 py-2 px-2'>
        <div className='max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-6 border-b-2 border-gray-600 py-8 px-4'>
            <div className='mx-2'>
                <h6 className='font-bold uppercase pt-2'>Address</h6>
                <ul>
                    <li className='pt-1'>Bridgnorth Road,</li>
                    <li >Stourton, Kinver</li>
                    <li >West Midlands,</li>
                    <li className='pb-1'>DY7 5BL</li>
                </ul>
            </div>
            <div className='mx-2'>
                <h6 className='font-bold uppercase pt-2'>Opening Times</h6>
                <ul>
                    <li className='py-1'>Mon: 12pm - Late</li>
                    <li className='py-1'>Tue - Sat: 8am - Late</li>
                    <li className='py-1'>Sun: 8am - 11pm</li>
                </ul>
            </div>
            <div className='mx-2'>
                <h6 className='font-bold uppercase pt-2'>Contact</h6>
                <ul>
                    <li className='pt-1 font-semibold font'>Phone:</li>
                    <a className='pb-1' href='tel:01384 872614'>01384 872614</a>
                    <li className='pt-1 font-semibold font'>General Enquiries:</li>
                    <a className='pb-1' href='mailto:foxinnstourton@gmail.com'>foxinnstourton@gmail.com</a>
                    <li className='pt-1 font-semibold font'>Weddings & Events:</li>
                    <a className='pb-1' href='mailto:events.foxinnstourton@gmail.com'>events.foxinnstourton@gmail.com</a>
                </ul>
            </div>
            <div className='mx-2'></div>
            <div className='col-span-2 py-8 md:pt-2'>
                <p className='font-bold uppercase'>Subscribe to our newsletter</p>
                <p className='py-4'>The latest deals, events, and updates sent to your inbox.</p>
                <form className='flex flex-col sm:flex-row' onSubmit={handleSubmit}>
                    <input 
                        className='w-full p-2 mr-4 rounded-md mb-4 text-black' 
                        type="email" 
                        placeholder='Enter email..' 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required 
                    />
                    <button className='p-2 mb-4 rounded-md' type="submit">Subscribe</button>
                </form>
                {message && <p className="mt-2 text-sm text-green-500">{message}</p>}
            </div>
        </div>

        <div className='flex flex-col max-w-[1400px] px-2 py-4 mx-auto justify-between sm:flex-row text-center'>
            <p className='py-4'>2025 The Fox Inn, All rghts reserved</p>
            <div className='flex justify-between sm:w-[300px]'>
                <img className='w-24' src={fourInABedWinner} alt="Four in a Bed Winner" />
                <img className='w-32' src={foodHygieneRating} alt="Food Hygiene Rating" />
            </div>
            <div className='flex justify-between sm:w-[300px] pt-4 text-2xl'>
                <a aria-label='Facebook link' href="https://www.facebook.com/fox.inn.5/">
                    <FaFacebook/>
                </a>
                <a aria-label='Instagram Link' href="https://www.instagram.com/foxinnstourton/">
                    <FaInstagram/>
                </a>
                <a aria-label='Trip Advisor Link' href="https://www.tripadvisor.co.uk/Restaurant_Review-g616275-d3490506-Reviews-The_Fox_Inn-Stourbridge_West_Midlands_England.html">
                    <FaTripadvisor/>
                </a>
            </div>
        </div>
    </div>
  )
}

export default Footer